// extracted by mini-css-extract-plugin
export const main = "_404-module--main--3Yt7t";
export const header = "_404-module--header--qy7lD";
export const image = "_404-module--image--2maBx";
export const forwarder = "_404-module--forwarder--4GBzR";